<template>
  <div class="bool-toggle" :class="rootClasses">
    <button class="bool-toggle__label-false" @click="toggleValue(false)">
      {{ labelFalse }}
    </button>
    <div class="bool-toggle__toggle-wrapper" @click="toggleValue(!initialValue)">
      <div class="bool-toggle__toggle-dot" />
    </div>
    <button class="bool-toggle__label-true" @click="toggleValue(true)">
      {{ labelTrue }}
    </button>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    labelTrue: String,
    labelFalse: String,
    initialValue: Boolean,
  },
  computed: {
    rootClasses () {
      return {
        'bool-toggle--is-true': this.initialValue,
        'bool-toggle--is-false': !this.initialValue,
      };
    },
  },
  methods: {
    toggleValue (newValue: boolean): void {
      this.$emit('on-change', newValue);
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/helpers";

.bool-toggle {
  $root: &;

  align-items: center;
  display: flex;
  gap: .25rem;

  &__toggle-wrapper {
    background-color: #FFFFFF;
    border: .1rem solid #000;
    border-radius: .7rem;
    cursor: pointer;
    padding: .1rem .1rem;
    width: 2.2rem;
  }

  &__toggle-dot {
    background-color: #000;
    border-radius: 50%;
    height: 1rem;
    transition: margin-left .25s;
    width: 1rem;

    #{$root}--is-true & {
      margin-left: .8rem;
    }
  }

  &__label-true,
  &__label-false {
    background: transparent;
    border: none;
    color: #707070;
    font-size: helpers.px-to-rem(14);
    transition: color .25s;
  }

  &--is-true &__label-true,
  &--is-false &__label-false {
    color: #000000;
  }
}
</style>
